import { render, staticRenderFns } from "./NhShell.vue?vue&type=template&id=2d9d159c"
import script from "./NhShell.vue?vue&type=script&lang=js"
export * from "./NhShell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports